<div class="mb-6 space-y-1 rounded-xl bg-grey-50 px-4 py-3">
  @if (branch) {
    <div
      data-test-id="branchMetaData"
      class="flex justify-between gap-4 text-lg"
    >
      <span class="">
        {{ 'models.branch.createdBy.label' | translate }}:
        <a
          data-test-id="branchCreatedBy"
          class="underline"
          [href]="`mailto:${branch.createdBy}`"
          >{{ branch.createdBy }}</a
        >
      </span>
      <span data-test-id="branchCreatedAt" class="">{{
        branch.createdAt | date: 'dd.MM.yyyy - HH:mm:ss'
      }}</span>
    </div>

    <div class="flex justify-between gap-4">
      <div>
        <span
          data-test-id="branchReason"
          class="after:mx-2 after:content-['•']"
        >
          {{ 'models.branch.reason.label' | translate }}:
          {{ branch.reason }}
        </span>
        <span
          data-test-id="branchSource"
          class="after:mx-2 after:content-['•']"
        >
          {{ 'models.branch.source.label' | translate }}:
          {{ branch.source }}
        </span>
        <span
          data-test-id="branchFundingCode"
          class="after:mx-2 after:content-['•'] after:last:content-none"
        >
          {{ 'models.branch.fundingCode.label' | translate }}:
          {{ branch.fundingCode }}
        </span>
        @if (branch.mevId) {
          <span data-test-id="branchMevId">
            {{ 'models.branch.mevId.label' | translate }}: {{ branch.mevId }}
          </span>
        }
      </div>
      <app-branch-status data-test-id="branchStatus" [status]="branch.state" />
    </div>
    @if (branch.note) {
      <div data-test-id="branchNote" class="text-sm text-grey-500">
        {{ 'models.branch.note.label' | translate }}: {{ branch.note }}
      </div>
    }
  } @else {
    <nz-skeleton [nzParagraph]="{ rows: 2 }" [nzActive]="true" />
  }
</div>

<div class="flex flex-col gap-6">
  <div class="flex flex-row gap-6">
    <app-value-filter
      data-test-id="validationFilter"
      [isLoading]="isLoading"
      [selected]="activeValidation"
      [options]="[
        {
          label: filterAllLabel,
          value: 'all',
          count: this.validationCounts.totalCountAll,
          icon: 'assets/icons/Maps_travel/marker-pin-01.svg',
        },
        {
          label: 'components.branchDetailBase.filter.isNewAddress' | translate,
          value: 'isNewAddress',
          count: this.validationCounts.totalNewAddresses,
          status: 'notice',
          icon: 'assets/icons/General/plus-circle.svg',
        },
        {
          label:
            'components.branchDetailBase.filter.isConflictAddress' | translate,
          value: 'isConflictAddress',
          count: this.validationCounts.totalConflictAddresses,
          status: 'error',
          icon: 'assets/icons/Alerts_feedback/alert-triangle.svg',
        },
        {
          label:
            'components.branchDetailBase.filter.isDuplicateWithChange'
            | translate,
          value: 'isDuplicateWithChange',
          count: this.validationCounts.totalDuplicateWithChanges,
          status: 'warning',
          icon: 'assets/icons/General/copy-02.svg',
        },
        {
          label:
            'components.branchDetailBase.filter.isDuplicateInCsv' | translate,
          value: 'isDuplicateInCsv',
          count: this.validationCounts.totalDuplicateInCsv,
          status: 'warning',
          icon: 'assets/icons/General/copy-03.svg',
        },
      ]"
      (selectionChange)="onValidationFilterChange($event)"
    />

    <div class="flex flex-col gap-6">
      <app-search-box
        data-test-id="searchBox"
        class="w-80"
        [isLoading]="isLoading"
        [defaultValue]="sword"
        (changeSearch)="onSearchFilterChange($event)"
      />

      @if (showResolvedSwitch) {
        <label class="flex gap-2 hover:cursor-pointer" for="showOnlyConflicts">
          {{ 'pages.clearingDetail.filter.showOnlyConflicts' | translate }}
          <nz-switch
            data-test-id="showOnlyConflicts"
            nzId="showOnlyConflicts"
            [(ngModel)]="showOnlyConflicts"
            (ngModelChange)="onShowOnlyConflicts()"
          />
        </label>
      }
    </div>
  </div>

  <app-table
    [tableColumns]="
      [
        {
          key: 'county',
          label: 'models.address.county.label' | translate,
          width: '130px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'place',
          label: 'models.address.place.label' | translate,
          width: '130px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'plz',
          label: 'models.address.plz.abbreviation' | translate,
          width: '80px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'streetName',
          label: 'models.address.streetName.label' | translate,
          width: '150px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'houseNumber',
          label: 'models.address.houseNumber.abbreviation' | translate,
          width: '100px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'houseNumberAddition',
          label: 'models.address.houseNumberAddition.label' | translate,
          width: '115px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'marking',
          label: 'models.address.marking.label' | translate,
          width: '120px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'parcelNumber',
          label: 'models.address.parcelNumber.label' | translate,
          width: '130px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'markingId',
          label: 'models.address.markingId.label' | translate,
          width: '130px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'parcelIdentifier',
          label: 'models.address.parcelIdentifier.label' | translate,
          width: '180px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'municipality',
          label: 'models.address.municipality.label' | translate,
          width: '120px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'municipalityId',
          label: 'models.address.municipalityId.label' | translate,
          width: '130px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'countyId',
          label: 'models.address.countyId.label' | translate,
          width: '120px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'district',
          label: 'models.address.district.label' | translate,
          width: '150px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'x',
          label: 'models.address.x.label' | translate,
          width: '100px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'y',
          label: 'models.address.y.label' | translate,
          width: '100px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'lat',
          label: 'models.address.lat.label' | translate,
          width: '160px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'lon',
          label: 'models.address.lon.label' | translate,
          width: '160px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'ags',
          label: 'models.address.ags.label' | translate,
          width: '100px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'oewId',
          label: 'models.address.oewId.label' | translate,
          width: '300px',
          cellTemplate: markedCellTemplate,
        },
        {
          key: 'uuId',
          label: 'models.address.uuId.label' | translate,
          width: '160px',
          cellTemplate: markedCellTemplate,
        },

        {
          key: 'numberOfHouseholds',
          label: 'models.address.numberOfHouseholds.oew_name' | translate,
          width: '60px',
        },
        {
          key: 'numberOfCompanies',
          label: 'models.address.numberOfCompanies.oew_name' | translate,
          width: '60px',
        },
        {
          key: 'minimumBandwidthDownload',
          label: 'models.address.minimumBandwidthDownload.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'minimumBandwidthUpload',
          label: 'models.address.minimumBandwidthUpload.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'minimumBandwidthTech',
          label: 'models.address.minimumBandwidthTech.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'addressHomePassed',
          label: 'models.address.addressHomePassed.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'plannedBandwidthDownload',
          label: 'models.address.plannedBandwidthDownload.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'plannedBandwidthUpload',
          label: 'models.address.plannedBandwidthUpload.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'plannedBandwidthTech',
          label: 'models.address.plannedBandwidthTech.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'plannedSupplyNotification',
          label:
            'models.address.plannedSupplyNotification.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'difficultAccessLocation',
          label: 'models.address.difficultAccessLocation.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'addressIndustrialArea',
          label: 'models.address.addressIndustrialArea.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'plannedCompletion',
          label: 'models.address.plannedCompletion.oew_name' | translate,
          width: '120px',
          cellTemplate: dateCellTemplate,
        },
        {
          key: 'plannedObtainingRightOfWay',
          label:
            'models.address.plannedObtainingRightOfWay.oew_name' | translate,
          width: '120px',
          cellTemplate: dateCellTemplate,
        },
        {
          key: 'telecommunicationCompany',
          label: 'models.address.telecommunicationCompany.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'socioEconomicFocusHospital',
          label:
            'models.address.socioEconomicFocusHospital.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'socioEconomicFocusSchool',
          label: 'models.address.socioEconomicFocusSchool.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'socioEconomicFocusOthers',
          label: 'models.address.socioEconomicFocusOthers.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'socioEconomicFocusComment',
          label:
            'models.address.socioEconomicFocusComment.oew_name' | translate,
          width: '250px',
        },
        {
          key: 'socioEconomicFocusUntlw',
          label: 'models.address.socioEconomicFocusUntlw.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'addressClassificationForSchool',
          label:
            'models.address.addressClassificationForSchool.oew_name'
            | translate,
          width: '120px',
        },
        {
          key: 'addressClassificationForHospital',
          label:
            'models.address.addressClassificationForHospital.oew_name'
            | translate,
          width: '120px',
        },
        {
          key: 'addressClassificationForDifficultarea',
          label:
            'models.address.addressClassificationForDifficultarea.oew_name'
            | translate,
          width: '120px',
        },
        {
          key: 'addressClassificationForCompanies',
          label:
            'models.address.addressClassificationForCompanies.oew_name'
            | translate,
          width: '120px',
        },
        {
          key: 'addressClassificationForEligibleCompanies',
          label:
            'models.address.addressClassificationForEligibleCompanies.oew_name'
            | translate,
          width: '140px',
        },
        {
          key: 'addressClassificationForSocioeconomicFocus',
          label:
            'models.address.addressClassificationForSocioeconomicFocus.oew_name'
            | translate,
          width: '150px',
        },
        {
          key: 'addressClassificationForPrivateHouseholds',
          label:
            'models.address.addressClassificationForPrivateHouseholds.oew_name'
            | translate,
          width: '140px',
        },
        {
          key: 'addressClassificationForPrivateSocioEconomicCompanies',
          label:
            'models.address.addressClassificationForPrivateSocioEconomicCompanies.oew_name'
            | translate,
          width: '180px',
        },
        {
          key: 'mevAlreadyFunded',
          label: 'models.address.mevAlreadyFunded.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'mevContradictionDate',
          label: 'models.address.mevContradictionDate.oew_name' | translate,
          width: '120px',
          cellTemplate: dateCellTemplate,
        },
        {
          key: 'addressRequest',
          label: 'models.address.addressRequest.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'addressRequestComment',
          label: 'models.address.addressRequestComment.oew_name' | translate,
          width: '250px',
        },
        {
          key: 'underSuppliedConnection',
          label: 'models.address.underSuppliedConnection.oew_name' | translate,
          width: '120px',
        },
        {
          key: 'underSuppliedConnectionComment',
          label:
            'models.address.underSuppliedConnectionComment.oew_name'
            | translate,
          width: '300px',
        },

        {
          key: 'mevId',
          label: 'models.address.mevId.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'oewServiceProvider',
          label: 'models.address.oewServiceProvider.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'networkOperator',
          label: 'models.address.networkOperator.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'geometry',
          label: 'models.address.geometry.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'streetId',
          label: 'models.address.streetId.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'postalStreetName',
          label: 'models.address.postalStreetName.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'oid',
          label: 'models.address.oid.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'nba',
          label: 'models.address.nba.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'qua',
          label: 'models.address.qua.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'federalStateId',
          label: 'models.address.federalStateId.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'federalState',
          label: 'models.address.federalState.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'regionId',
          label: 'models.address.regionId.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'region',
          label: 'models.address.region.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'districtId',
          label: 'models.address.districtId.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'postalTown',
          label: 'models.address.postalTown.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'postalDistrict',
          label: 'models.address.postalDistrict.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'municipalityAddition',
          label: 'models.address.municipalityAddition.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'cadastralParcelNumber',
          label: 'models.address.cadastralParcelNumber.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'buildingId',
          label: 'models.address.buildingId.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'buildingFunction',
          label: 'models.address.buildingFunction.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'buildingDesc',
          label: 'models.address.buildingDesc.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'techDesc',
          label: 'models.address.techDesc.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'vzkCableLength',
          label: 'models.address.vzkCableLength.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'projectDataId',
          label: 'models.address.projectDataId.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'numberOfEmployees',
          label: 'models.address.numberOfEmployees.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'annualTurnoverOfCompany',
          label: 'models.address.annualTurnoverOfCompany.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'totalAssetsOfCompany',
          label: 'models.address.totalAssetsOfCompany.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'agriculturalBusiness',
          label: 'models.address.agriculturalBusiness.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'evaluationUpgradeMunicipality',
          label:
            'models.address.evaluationUpgradeMunicipality.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'evaluationUpgradeMunicipalityComment',
          label:
            'models.address.evaluationUpgradeMunicipalityComment.oew_name'
            | translate,
          width: '300px',
        },
        {
          key: 'connectedAccordingRl',
          label: 'models.address.connectedAccordingRl.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'notConnectedComment',
          label: 'models.address.notConnectedComment.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'seeAccordingTender',
          label: 'models.address.seeAccordingTender.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'modificationAttributeTender',
          label:
            'models.address.modificationAttributeTender.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'modificationComment',
          label: 'models.address.modificationComment.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'generalComment',
          label: 'models.address.generalComment.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'eligible',
          label: 'models.address.eligible.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'notEligible',
          label: 'models.address.notEligible.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'projectTypes',
          label: 'models.address.projectTypes.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'socioEconomicFocusCompanies',
          label:
            'models.address.socioEconomicFocusCompanies.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'socioEconomicFocusAgriculturalBusiness',
          label:
            'models.address.socioEconomicFocusAgriculturalBusiness.oew_name'
            | translate,
          width: '300px',
        },
        {
          key: 'mevDate',
          label: 'models.address.mevDate.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'reportedOperator',
          label: 'models.address.reportedOperator.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'addressStatus',
          label: 'models.address.addressStatus.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'addressStatusCause',
          label: 'models.address.addressStatusCause.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'addressStatusComment',
          label: 'models.address.addressStatusComment.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'losPlan',
          label: 'models.address.losPlan.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'losBau',
          label: 'models.address.losBau.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'losNetz',
          label: 'models.address.losNetz.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'abrufPlan',
          label: 'models.address.abrufPlan.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'abrufBau',
          label: 'models.address.abrufBau.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'abrufNetz',
          label: 'models.address.abrufNetz.oew_name' | translate,
          width: '300px',
        },
        {
          key: 'referenceNumberForFundingProgram',
          label:
            'models.address.referenceNumberForFundingProgram.oew_name'
            | translate,
          width: '300px',
        },
        {
          key: 'fundingProgram',
          label: 'models.address.fundingProgram.oew_name' | translate,
          width: '300px',
        },

        {
          key: 'validationSummary',
          label: 'pages.uploadDetail.table.validationSummary.label' | translate,
          width: '170px',
          cellTemplate: validationSummaryCellTemplate,
          fixRight: true,
          sort: false,
        },
      ] | mergeColumns: tableColumns
    "
    [tableData]="tableData"
    [total]="total"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [isLoading]="isLoading"
    [defaultSorting]="this.activeSorting"
    (changeHandler)="changeTableHandler($event)"
  />
</div>

<ng-template
  #validationSummaryCellTemplate
  let-currentRow="currentRow"
  [typedTemplate]="typeToken"
>
  <div data-test-id="validationSummary" class="mt-2 flex flex-wrap gap-2">
    @if (currentRow.isConflictAddress) {
      <app-number data-test-id="isConflictAddress" size="small" type="error">
        {{ 'models.conflict.isConflictAddress.label' | translate }}
      </app-number>
    }
    @if (currentRow.isNewAddress) {
      <app-number data-test-id="isNewAddress" size="small" type="notice">
        {{ 'models.conflict.isNewAddress.label' | translate }}
      </app-number>
    }
    @if (currentRow.isDuplicateWithChange) {
      <app-number
        data-test-id="isDuplicateWithChange"
        size="small"
        type="warning"
      >
        {{ 'models.conflict.isDuplicateWithChange.label' | translate }}
      </app-number>
    }
    @if (currentRow.isDuplicateInCsv) {
      <app-number data-test-id="isDuplicateInCsv" size="small" type="warning">
        {{ 'models.conflict.isDuplicateInCsv.label' | translate }}
      </app-number>
    }
  </div>
</ng-template>

<ng-template #dateCellTemplate let-item="item">
  <div data-test-id="dateCell">{{ item | date: 'dd.MM.yyyy - HH:mm:ss' }}</div>
</ng-template>

<ng-template #markedCellTemplate let-item="item">
  <div
    data-test-id="markedCell"
    [innerHTML]="item | highLightText: sword"
  ></div>
</ng-template>
